import Logger from '../logger';

const onCloseHandler = (args, callbacks) => {
    const closerState = window.WC._localStorage.get('CloserState');
    Logger.log('onClose ->', { ...args, closerState: closerState });

    if (closerState === 'opened') {
        window.WC._localStorage.set('CloserState', 'closed');
    }
    if (['closed', 'hidden', 'initialized'].includes(closerState)) {
        Logger.log('Closer not opened');
        return;
    }
    if (callbacks && callbacks.onMinimize) {
        window.WC._localStorage.set('CloserState', 'hidden');
        callbacks.onMinimize();
    }
    if (callbacks && callbacks.onClose) {
        window.WC.Closer.close('onNativeClose', args, callbacks.onClose);
    }
};

export { onCloseHandler };
